import {UI} from "../../../../../stem-core/ui/UIBase";
import {BlinkSDKInputField, SDKArrayInput} from "../../components/Primitives.jsx";
import {SubscriptionOffer} from "../../../../../blinkpay/State";
import {VisibilityStatus} from "../../../../../client/state/misc/GenericEnums";
import {MerchantAudience} from "../../../../../client/state/merchant/MerchantAudienceStore";
import {PanelEditorTabStyle} from "./PanelEditorTabStyle";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {DropdownInput} from "../../../../../core/ui/input/dropdown/DropdownInput.jsx";
import type {PanelEditorState} from "../PanelEditorState";
import type {StoreId} from "../../../../../stem-core/state/State";


interface PanelOffersEditorOptions {
    state?: PanelEditorState;
}

@registerStyle(PanelEditorTabStyle)
export class PanelOffersEditor extends UI.Element<PanelOffersEditorOptions> {
    render() {
        const {state} = this.options;
        const {merchantId} = state.panel;

        const subscriptionOffers = SubscriptionOffer.filterBy({merchantId: merchantId})
            .filter(({visibility}) => visibility === VisibilityStatus.HIDDEN || visibility === VisibilityStatus.PUBLIC);
        const newsletterOffers = MerchantAudience.filterBy({merchantId: merchantId, isPublic: true});

        return [
            <BlinkSDKInputField
                label="Subscription offers"
                optional
                stateKey={["panelOptions", "subscriptionOffer"]}
                state={state}
                InputClass={SDKArrayInput}
                inputOptions={{
                    box: false,
                    addButtonLabel: "Add subscription offer",
                    ElementInputClass: DropdownInput,
                    elementInputOptions: {
                        formatter: (id: StoreId) => SubscriptionOffer.get(id),
                        options: subscriptionOffers.map(offer => offer.id),
                    }
                }}/>,

            <div />, // To align them on top of another

            <BlinkSDKInputField
                label="Newsletters"
                optional
                stateKey={["panelOptions", "newsletter"]}
                state={state}
                InputClass={SDKArrayInput}
                inputOptions={{
                    box: false,
                    addButtonLabel: "Add newsletter",
                    ElementInputClass: DropdownInput,
                    elementInputOptions: {
                        formatter: (id: StoreId) => MerchantAudience.get(id),
                        options: newsletterOffers.map(offer => offer.id),
                    }
                }}/>,
        ]
    }
}
